import { createSlice } from "@reduxjs/toolkit";

import {
  LAYOUT_CONTENT_WIDTH,
  LAYOUT_DIRECTION,
  LAYOUT_MODE_TYPES,
  LAYOUT_SKIN,
  LAYOUT_TOPBAR_THEME_TYPES,
  LAYOUT_TYPES,
  LEFT_NAVIGATION_TYPES,
  LEFT_SIDEBAR_COLOR_TYPES,
  LEFT_SIDEBAR_SIZE_TYPES,
} from "Common/constants/layout";

export interface LayoutState {
  layoutType: LAYOUT_TYPES.VERTICAL;
  layoutSkintype: LAYOUT_SKIN.DEFAULT;
  layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE | LAYOUT_MODE_TYPES.DARKMODE;
  layoutDirectionType: LAYOUT_DIRECTION.LTR;
  layoutContentWidthType: LAYOUT_CONTENT_WIDTH.FLUID;
  layoutSidebarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT | LEFT_SIDEBAR_SIZE_TYPES.SMALLICON;
  layoutNavigationType: LEFT_NAVIGATION_TYPES.STICKY;
  layoutSidebarColorType: LEFT_SIDEBAR_COLOR_TYPES.LIGHT | LEFT_SIDEBAR_COLOR_TYPES.DARK;
  layoutTopbarColorType: LAYOUT_TOPBAR_THEME_TYPES.LIGHT | LAYOUT_TOPBAR_THEME_TYPES.DARK;
}

const getInitialLayoutMode = () => {
  try {
    const savedTheme = localStorage.getItem("app-theme");
    return savedTheme === "dark" ? LAYOUT_MODE_TYPES.DARKMODE : LAYOUT_MODE_TYPES.LIGHTMODE;
  } catch (error) {
    console.warn("Erro ao carregar tema do localStorage:", error);
    return LAYOUT_MODE_TYPES.LIGHTMODE;
  }
};

const getInitialColors = (mode: string) => {
  if (mode === LAYOUT_MODE_TYPES.DARKMODE) {
    return {
      sidebar: LEFT_SIDEBAR_COLOR_TYPES.DARK,
      topbar: LAYOUT_TOPBAR_THEME_TYPES.DARK,
    };
  }
  return {
    sidebar: LEFT_SIDEBAR_COLOR_TYPES.LIGHT,
    topbar: LAYOUT_TOPBAR_THEME_TYPES.LIGHT,
  };
};

const initialLayoutMode = getInitialLayoutMode();
const initialColors = getInitialColors(initialLayoutMode);

export const initialState: LayoutState = {
  layoutType: LAYOUT_TYPES.VERTICAL,
  layoutSkintype: LAYOUT_SKIN.DEFAULT,
  layoutModeType: initialLayoutMode,
  layoutDirectionType: LAYOUT_DIRECTION.LTR,
  layoutContentWidthType: LAYOUT_CONTENT_WIDTH.FLUID,
  layoutSidebarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT,
  layoutNavigationType: LEFT_NAVIGATION_TYPES.STICKY,
  layoutSidebarColorType: initialColors.sidebar,
  layoutTopbarColorType: initialColors.topbar,
};

const LayoutSlice = createSlice({
  name: "LayoutSlice",
  initialState,
  reducers: {
    changeLayoutModeAction(state: any, action: any) {
      state.layoutModeType = action.payload;

      if (action.payload === LAYOUT_MODE_TYPES.DARKMODE) {
        state.layoutSidebarColorType = LEFT_SIDEBAR_COLOR_TYPES.DARK;
        state.layoutTopbarColorType = LAYOUT_TOPBAR_THEME_TYPES.DARK;
      } else {
        state.layoutSidebarColorType = LEFT_SIDEBAR_COLOR_TYPES.LIGHT;
        state.layoutTopbarColorType = LAYOUT_TOPBAR_THEME_TYPES.LIGHT;
      }
    },
    changeLayoutSidebarSizeAction(state: any, action: any) {
      state.layoutSidebarSizeType = action.payload;
    },
  },
});

export const { changeLayoutModeAction, changeLayoutSidebarSizeAction } = LayoutSlice.actions;

export default LayoutSlice.reducer;
